var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic:baseline-telegram"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14 2.33333C7.55998 2.33333 2.33331 7.55999 2.33331 14C2.33331 20.44 7.55998 25.6667 14 25.6667C20.44 25.6667 25.6666 20.44 25.6666 14C25.6666 7.55999 20.44 2.33333 14 2.33333ZM19.4133 10.2667C19.2383 12.11 18.48 16.59 18.095 18.655C17.9316 19.53 17.605 19.8217 17.3016 19.8567C16.625 19.915 16.1116 19.4133 15.4583 18.9817C14.4316 18.305 13.8483 17.885 12.8566 17.2317C11.7016 16.4733 12.4483 16.0533 13.1133 15.3767C13.2883 15.2017 16.275 12.4833 16.3333 12.2383C16.3414 12.2012 16.3403 12.1627 16.3302 12.1261C16.32 12.0895 16.3011 12.0559 16.275 12.0283C16.205 11.97 16.1116 11.9933 16.03 12.005C15.925 12.0283 14.2916 13.1133 11.1066 15.26C10.64 15.575 10.22 15.7383 9.84665 15.7267C9.42665 15.715 8.63331 15.4933 8.03831 15.295C7.30331 15.0617 6.73165 14.9333 6.77831 14.525C6.80165 14.315 7.09331 14.105 7.64165 13.8833C11.0483 12.4017 13.3116 11.4217 14.4433 10.955C17.6866 9.60166 18.3516 9.36833 18.795 9.36833C18.8883 9.36833 19.11 9.39166 19.25 9.50833C19.3666 9.60166 19.4016 9.72999 19.4133 9.82333C19.4016 9.89333 19.425 10.1033 19.4133 10.2667Z",
    fill: "#3F9EF6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTelegram);
export default __webpack_public_path__ + "static/media/ic-telegram.1c5c017e1fa2561d0e44777d2e0f7a6d.svg";
export { ForwardRef as ReactComponent };